import { Injectable } from '@angular/core';
import { DropdownOption } from '@platform-workspace/design-system';
import { CountryCode, PhoneNumber } from 'libphonenumber-js';

@Injectable({
  providedIn: 'root',
})
export class LibPhoneNumberService {
  private readonly libLoader: Promise<typeof import('libphonenumber-js')>;

  constructor() {
    this.libLoader = import('libphonenumber-js');
  }

  async parseNumber(phoneNumber: string, defaultCountry: string): Promise<PhoneNumber | null> {
    const { parsePhoneNumberWithError } = await this.libLoader;

    try {
      return parsePhoneNumberWithError(phoneNumber, this.formatCountriesForLib(defaultCountry));
    } catch (error) {
      return null;
    }
  }

  async getCountryCallingCode(countryCode: string): Promise<string> {
    const { getCountryCallingCode } = await this.libLoader;
    return getCountryCallingCode(this.formatCountriesForLib(countryCode));
  }

  isWhitelistCountry(countries: DropdownOption[], libCountry: string): boolean {
    return countries.some((country) => {
      const formattedCountry = this.formatCountriesForLib(country.value as string);
      return formattedCountry === libCountry;
    });
  }

  private formatCountriesForLib(countryCode: string): CountryCode {
    return (countryCode === 'UK' ? 'GB' : countryCode) as CountryCode;
  }
}
